import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { FormControl, FormHelperText, ListSubheader, MenuItem, InputLabel as MuiInputLabel, Select as MuiSelect, Checkbox, ListItemText } from '@material-ui/core';
import { v4 as uuid } from 'uuid';

var Select = function Select(_ref) {
  var a11yLabel = _ref.a11yLabel,
      children = _ref.children,
      disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      e2e = _ref.e2e,
      fullWidth = _ref.fullWidth,
      helperText = _ref.helperText,
      label = _ref.label,
      multiple = _ref.multiple,
      value = _ref.value,
      name = _ref.name,
      error = _ref.error,
      required = _ref.required;
  var labelId = uuid();
  var inputId = uuid(); // Prevent component from rendering in uncontrolled state.
  // See https://reactjs.org/docs/uncontrolled-components.html

  if (value === undefined) {
    return null;
  }

  var getChildren = function getChildren() {
    if (!multiple || !children) {
      return children;
    }

    return Array.from(children).map(function (child) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: child.props.value,
        key: child.props.value
      }, /*#__PURE__*/React.createElement(Checkbox, {
        color: "primary",
        checked: Array.from(value).indexOf(child.props.value) > -1
      }), /*#__PURE__*/React.createElement(ListItemText, {
        primary: child.props.children
      }));
    });
  };

  var getHiddenChildren = function getHiddenChildren() {
    var _React$Children$map;

    if (!children) {
      return null;
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, (_React$Children$map = React.Children.map(children, function (untypedChild) {
      var child = untypedChild;

      if (!child) {
        return;
      }

      if (child.props.value) {
        return /*#__PURE__*/React.createElement("option", _extends({
          value: child.props.value,
          key: child.props.value
        }, e2e && {
          'data-e2e': "".concat(e2e, "-select-opt-").concat(child.props.value)
        }), child.props.children);
      }
    })) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.filter(Boolean));
  };

  return /*#__PURE__*/React.createElement(FormControl, _extends({}, e2e && {
    'data-e2e': e2e
  }, {
    variant: "outlined",
    size: "small",
    error: error,
    fullWidth: fullWidth,
    required: required
  }), label && /*#__PURE__*/React.createElement(MuiInputLabel, _extends({
    id: labelId,
    htmlFor: inputId
  }, e2e && {
    'data-e2e': "".concat(e2e, "-label")
  }), label), /*#__PURE__*/React.createElement(MuiSelect, {
    "aria-label": a11yLabel,
    disabled: disabled,
    name: name,
    labelId: labelId,
    onChange: dsOnChange,
    value: value,
    label: label,
    inputProps: _objectSpread({
      id: inputId
    }, e2e && {
      'data-e2e': "".concat(e2e, "-input")
    }),
    renderValue: multiple ? function (selected) {
      return children.filter(function (child) {
        return Array.from(selected).indexOf(child.props.value) > -1;
      }).map(function (child) {
        return child.props.children;
      }).join(', ');
    } : undefined,
    multiple: multiple,
    displayEmpty: true
  }, getChildren()), /*#__PURE__*/React.createElement("select", _extends({
    style: {
      display: 'none'
    },
    "aria-hidden": true,
    name: name,
    onChange: function onChange(event) {
      if (!event.target) {
        return;
      }

      var selectedElems = Array.from(event.target.querySelectorAll('option:checked'));
      var selectedValues = selectedElems.map(function (elem) {
        return isNaN(Number(elem.value)) ? String(elem.value) : Number(elem.value);
      });

      var newEvent = _objectSpread(_objectSpread({}, event), {}, {
        target: _objectSpread(_objectSpread({}, event.target), {}, {
          value: multiple ? selectedValues : selectedValues[0]
        })
      });

      dsOnChange === null || dsOnChange === void 0 ? void 0 : dsOnChange(newEvent, newEvent.target);
    },
    value: value
  }, e2e && {
    'data-e2e': "".concat(e2e, "-select")
  }, {
    multiple: multiple
  }), /*#__PURE__*/React.createElement("option", {
    value: "",
    style: {
      display: 'none'
    },
    disabled: true
  }), getHiddenChildren()), !!helperText && /*#__PURE__*/React.createElement(FormHelperText, e2e && {
    'data-e2e': "".concat(e2e, "-helperText")
  }, helperText));
};

export default Select;
export var SelectSubheader = ListSubheader;
SelectSubheader.displayName = 'SelectSubheader';
export var SelectItem = MenuItem;
SelectItem.displayName = 'SelectItem';

try {
  Select.__docgenInfo = {
    description: '',
    displayName: 'Select',
    methods: [],
    props: {
      a11yLabel: {
        defaultValue: null,
        description: 'ARIA label. Use if component if not accompanied by a visible label.',
        name: 'a11yLabel',
        required: false,
        type: {
          name: 'string'
        }
      },
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<{ name?: string; value: unknown; }>, child: ReactNode) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: false,
        type: {
          name: 'string'
        }
      },
      helperText: {
        defaultValue: null,
        description: '',
        name: 'helperText',
        required: false,
        type: {
          name: 'string'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the `input` element will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      name: {
        defaultValue: null,
        description: 'Name attribute of the `input` element.',
        name: 'name',
        required: false,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: null,
        description: 'The input value. Providing an empty string will select no options.\n' + 'This prop is required when the `native` prop is `false` (default).\n' + "Set to an empty string `''` if you don't want any of the available options to be selected.\n" + '\n' + 'If the value is an object it must have reference equality with the option in order to be selected.\n' + 'If the value is not an object, the string representation must match with the string representation of the option in order to be selected.\n' + '@document',
        name: 'value',
        required: false,
        type: {
          name: 'unknown'
        }
      },
      multiple: {
        defaultValue: null,
        description: 'If `true`, `value` must be an array and the menu will support multiple selections.',
        name: 'multiple',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      fullWidth: {
        defaultValue: null,
        description: 'If `true`, the component will take up the full width of its container.',
        name: 'fullWidth',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      error: {
        defaultValue: null,
        description: 'If `true`, the label should be displayed in an error state.',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the label will indicate that the input is required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}

try {
  SelectSubheader.__docgenInfo = {
    description: '',
    displayName: 'SelectSubheader',
    methods: [],
    props: {}
  };
} catch (e) {}

try {
  SelectItem.__docgenInfo = {
    description: '',
    displayName: 'SelectItem',
    methods: [],
    props: {
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        required: false,
        type: {
          name: 'string | number | readonly string[]'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map